import React from 'react'

import { Hero } from './Hero'
import { Teams } from './Teams'
import { Venues } from './Venues'
import { Events } from './Events'

import './browseWrapper.scss'

export default function BrowseWrapper({ events, venues, organizations }) {
  return (
    <>
      <main className="browse-wrapper">
        <Hero />
        <Events events={events} />
        <Teams organizations={organizations} />
        <Venues venues={venues} />
      </main>
    </>
  )
}
